export enum CourseProgressState {
    NOTSTARTED = "NOTSTARTED",
    INPROGRESS = "INPROGRESS",
    FINISHEDWATCHING = "FINISHEDWATCHING",
    COMPLETED = "COMPLETED",
  }
